import React from 'react';

interface TagSidebarProps {
  tags: string[];
  tagCounts: Record<string, number>;
  selectedTags: string[];
  onToggleTag: (tag: string) => void;
  onCreateTag: () => void;
}

const TagSidebar: React.FC<TagSidebarProps> = ({ tags, tagCounts, selectedTags, onToggleTag, onCreateTag }) => {
  return (
    <aside className="w-full lg:w-64 bg-white border-r border-slate-200 p-3 lg:p-4 h-full flex flex-col min-w-0">
      <div className="flex items-center justify-between mb-3 lg:mb-4">
        <h2 className="font-bold text-base lg:text-lg truncate">Tags</h2>
        <button className="btn btn-xs px-2 py-1 text-xs" onClick={onCreateTag}>+ New</button>
      </div>
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        {tags.length === 0 && <div className="text-gray-400 text-sm">No tags yet.</div>}
        {tags.map(tag => (
          <div
            key={tag}
            className={`flex items-center justify-between px-2 py-1 rounded cursor-pointer mb-1 text-sm ${selectedTags.includes(tag) ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'}`}
            onClick={() => onToggleTag(tag)}
          >
            <span className="truncate flex-1">#{tag}</span>
            <span className="text-xs text-gray-500 ml-2 flex-shrink-0">{tagCounts[tag] || 0}</span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default TagSidebar; 